import { Component, OnInit } from '@angular/core';
import { ArquivoImportacaoSva } from 'src/app/model/arquivoImportacaoSva';
import { ArquivoImportacaoSvaService } from 'src/app/service/arquivoImportacaoSva.service';
import { ImportacaoSvaService } from 'src/app/service/importacaoSva.service';

@Component({
  selector: 'app-importacao-sva',
  templateUrl: './importacao-sva.component.html',
  styleUrls: ['./importacao-sva.component.css']
})
export class ImportacaoSvaComponent implements OnInit {
  selectedFile?: File;
  filesList: Array<ArquivoImportacaoSva> = [];

  constructor(private importacaoSvaService: ImportacaoSvaService,
    private arquivoImportacaoSvaService: ArquivoImportacaoSvaService) { }

  ngOnInit(): void {
    this.listaArquivos();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.selectedFile = input.files[0];
    }
  }

  listaArquivos(){
    this.arquivoImportacaoSvaService.findAll().subscribe({
      next: (result: any) => this.filesList = result.data
    })
  }

  uploadFile() {
    if (this.selectedFile) {
      this.importacaoSvaService.uploadFile(this.selectedFile).subscribe(
        (data) => { 
          this.listaArquivos();
         },
        (error) => { console.error('Upload failed', error); }
      );
    }
  }

}
